var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfetti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.425,
    height: 90.943,
    viewBox: "0 0 94.425 90.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2542",
    "data-name": "Group 2542",
    transform: "translate(-7945.764 17535.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "confetti",
    transform: "translate(7956.236 -17526.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M4.961,57.685,27.342,14.959a3.494,3.494,0,0,1,5.567-.849L50.894,32.1a3.494,3.494,0,0,1-.849,5.567L7.319,60.044a1.747,1.747,0,0,1-2.359-2.359Z",
    transform: "translate(-4.761 15.812)",
    fill: "#ffcc5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M50.891,32.1,32.906,14.11a3.494,3.494,0,0,0-5.567.849l-.2.377,6.545,6.545a10.483,10.483,0,0,1-2.547,16.7L8.854,50.256,4.962,57.685A1.747,1.747,0,0,0,7.32,60.044L50.046,37.662a3.494,3.494,0,0,0,.846-5.567Z",
    transform: "translate(-4.758 15.812)",
    fill: "#f7b546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M13.924,53.237,18.3,50.945,7.173,47.468,5.527,50.613ZM9.905,42.251,25.56,47.143l4.378-2.292L11.555,39.106Zm4.378-8.362,22.909,7.16,4.378-2.292L15.933,30.743Zm4.382-8.359,29.957,9.362a3.4,3.4,0,0,0,1.261-3.267L20.315,22.385,18.666,25.53Zm4.378-8.359,19.429,6.07-5.325-5.322L24.69,14.026Z",
    transform: "translate(-2.85 18.157)",
    fill: "#f47423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M49.881,31.113,34.792,26.4a10.536,10.536,0,0,1-.566,3.484l14.4,4.5a3.512,3.512,0,0,0,1.059-1.415l.049-.122a3.449,3.449,0,0,0,.15-1.73ZM29.939,44.339,19.193,40.981l-4.378,2.292L25.56,46.631l1.02-.535Zm1.838-25.314c.15.15.241.325.377.482l10.315,3.225-5.325-5.326L26.979,14.231l4.8,4.794ZM5.527,50.1l8.4,2.624L18.3,50.433,7.557,47.075l-.615.325Zm23.7-14.376-2.778,1.457L37.2,40.541l4.378-2.292L30.568,34.81a11.292,11.292,0,0,1-1.338.916Z",
    transform: "translate(-2.85 18.668)",
    fill: "#ed5d25"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-star",
    "data-name": "Icon akar-star",
    d: "M10.811,3.545a.855.855,0,0,1,1.594,0l1.782,4.936a.852.852,0,0,0,.8.545h4.379a.838.838,0,0,1,.526,1.5l-3.116,2.8a.833.833,0,0,0-.277.94l1.138,4.823a.848.848,0,0,1-1.3.963L12.1,17.371a.861.861,0,0,0-.99,0L6.88,20.057a.849.849,0,0,1-1.3-.963L6.72,14.27a.833.833,0,0,0-.277-.94l-3.116-2.8a.838.838,0,0,1,.525-1.5H8.231a.851.851,0,0,0,.8-.545L10.81,3.545Z",
    transform: "translate(7942.765 -17464.746)",
    fill: "#07b7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-star-2",
    "data-name": "Icon akar-star",
    d: "M7.755,3.332a.521.521,0,0,1,.971,0L9.811,6.337a.519.519,0,0,0,.485.332h2.666a.51.51,0,0,1,.32.914l-1.9,1.707a.507.507,0,0,0-.169.572l.693,2.937a.517.517,0,0,1-.79.586L8.542,11.75a.524.524,0,0,0-.6,0L5.362,13.385a.517.517,0,0,1-.79-.586l.693-2.937A.507.507,0,0,0,5.1,9.289L3.2,7.582a.51.51,0,0,1,.32-.914H6.184a.518.518,0,0,0,.485-.332L7.755,3.332Z",
    transform: "translate(7990.654 -17538.473)",
    fill: "#fcb424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-star-3",
    "data-name": "Icon akar-star",
    d: "M7.755,3.332a.521.521,0,0,1,.971,0L9.811,6.337a.519.519,0,0,0,.485.332h2.666a.51.51,0,0,1,.32.914l-1.9,1.707a.507.507,0,0,0-.169.572l.693,2.937a.517.517,0,0,1-.79.586L8.542,11.75a.524.524,0,0,0-.6,0L5.362,13.385a.517.517,0,0,1-.79-.586l.693-2.937A.507.507,0,0,0,5.1,9.289L3.2,7.582a.51.51,0,0,1,.32-.914H6.184a.518.518,0,0,0,.485-.332L7.755,3.332Z",
    transform: "translate(7973.654 -17515.887)",
    fill: "#fcb424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-star-4",
    "data-name": "Icon akar-star",
    d: "M7.755,3.332a.521.521,0,0,1,.971,0L9.811,6.337a.519.519,0,0,0,.485.332h2.666a.51.51,0,0,1,.32.914l-1.9,1.707a.507.507,0,0,0-.169.572l.693,2.937a.517.517,0,0,1-.79.586L8.542,11.75a.524.524,0,0,0-.6,0L5.362,13.385a.517.517,0,0,1-.79-.586l.693-2.937A.507.507,0,0,0,5.1,9.289L3.2,7.582a.51.51,0,0,1,.32-.914H6.184a.518.518,0,0,0,.485-.332L7.755,3.332Z",
    transform: "translate(8016.225 -17524.674)",
    fill: "#07b7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-star-5",
    "data-name": "Icon akar-star",
    d: "M7.755,3.332a.521.521,0,0,1,.971,0L9.811,6.337a.519.519,0,0,0,.485.332h2.666a.51.51,0,0,1,.32.914l-1.9,1.707a.507.507,0,0,0-.169.572l.693,2.937a.517.517,0,0,1-.79.586L8.542,11.75a.524.524,0,0,0-.6,0L5.362,13.385a.517.517,0,0,1-.79-.586l.693-2.937A.507.507,0,0,0,5.1,9.289L3.2,7.582a.51.51,0,0,1,.32-.914H6.184a.518.518,0,0,0,.485-.332L7.755,3.332Z",
    transform: "translate(8026.707 -17503.832)",
    fill: "#ee480e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-star-6",
    "data-name": "Icon akar-star",
    d: "M7.755,3.332a.521.521,0,0,1,.971,0L9.811,6.337a.519.519,0,0,0,.485.332h2.666a.51.51,0,0,1,.32.914l-1.9,1.707a.507.507,0,0,0-.169.572l.693,2.937a.517.517,0,0,1-.79.586L8.542,11.75a.524.524,0,0,0-.6,0L5.362,13.385a.517.517,0,0,1-.79-.586l.693-2.937A.507.507,0,0,0,5.1,9.289L3.2,7.582a.51.51,0,0,1,.32-.914H6.184a.518.518,0,0,0,.485-.332L7.755,3.332Z",
    transform: "translate(8004.386 -17485.832)",
    fill: "#ee480e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M8091.369-17661.609l19.619-23.172,4.059,4.906-22.98,19.205Z",
    transform: "translate(-95.823 171.895)",
    fill: "#07b7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M8089.85-17697.883c3.618,12.395-6.236,26.176-6.236,26.176l1.463,1.461s10.777-12.855,10.47-20.016-1.078-7.621-1.078-7.621Z",
    transform: "translate(-92.677 177.209)",
    fill: "#fcb424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M5.7,0c-3.619,12.395,6.236,26.175,6.236,26.175l-1.462,1.462S-.3,14.78.006,7.621,1.084,0,1.084,0Z",
    transform: "translate(8026.493 -17498.084) rotate(87)",
    fill: "#ed3f03"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/Confetti.3312128b.svg";
export { ForwardRef as ReactComponent };